import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-debounce-input',
  templateUrl: './debounce-input.component.html',
  styleUrls: ['./debounce-input.component.css']
})
export class DebounceInputComponent implements OnInit, OnDestroy {

  @Input() placeholder: string = 'Type here...';
  @Input() delay: number = 1000; // Delay dalam ms
  @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();

  private inputSubject: Subject<string> = new Subject<string>();

  ngOnInit(): void {
    this.inputSubject.pipe(
      debounceTime(this.delay),
      distinctUntilChanged()
    ).subscribe(value => {
      this.valueChange.emit(value);
      // console.log('Value changed:', value);
    });
  }

  onInputChange(event: Event): void {
    if (event) {
      const target = event.target as HTMLInputElement;
      this.inputSubject.next(target.value);
    }
  }

  ngOnDestroy(): void {
    this.inputSubject.unsubscribe();
  }

}
